import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalHeader, ModalBody, Alert } from 'reactstrap'
import { createSelector } from 'reselect'
import { toggleFacebookPublishSuccessModal } from '../../../../../../slices/modals/reducer';
import PrismCode from '../../../../../../Components/Common/Prism';

function PublishSuccessModal() {
  const dispatch = useDispatch();
  const selectState = createSelector(state => state, state => ({
    modalState: state.Modal.facebookPublishSuccessModal,
    facebookPublishMessage: state.Campaign.facebookPublishMessage
  }));
  const { modalState, facebookPublishMessage } = useSelector(selectState);


  function closeModal() {
    dispatch(toggleFacebookPublishSuccessModal());
  }

  return (
    <Modal isOpen={modalState} toggle={closeModal} centered size='md'>
      <ModalHeader className='p-3' toggle={closeModal}>
        <b>Publish Success</b>
      </ModalHeader>
      <ModalBody>
        {facebookPublishMessage ?
          <React.Fragment>
            <Alert color='success' className='alert-additional text-primary'>
              <div className='alert-body'>
                <div className='d-flex'>
                  <div className='flex-shrink-0 me-3'>
                    <i className="ri-notification-off-line fs-16 align-middle"></i>
                  </div>
                  <div className='flex-grow-1'>
                    <h5 className='alert-heading'>Your creatives published correctly</h5>
                    <p className='mb-0'>Yey! Everything worked!</p>
                  </div>
                </div>
              </div>
            </Alert>
            <PrismCode
              code={facebookPublishMessage}
              language={"html"}
            />
          </React.Fragment>
          : null}

      </ModalBody>
    </Modal>
  )
}

export default PublishSuccessModal
